var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48095683"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9.00977,
    id: "Ellipse 83",
    r: 5.3,
    stroke: "currentColor",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.0098C24 21.4869 19.5228 17.0098 14 17.0098C8.47715 17.0098 4 21.4869 4 27.0098",
    id: "Ellipse 84",
    stroke: "currentColor",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 26.6,
    id: "Rectangle 19841",
    rx: 5.3,
    stroke: "currentColor",
    strokeWidth: 1.4,
    width: 26.6,
    x: 0.7,
    y: 0.709766
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.81d9479950faf32cb23e14eaf41830e3.svg";
export { ForwardRef as ReactComponent };